const fields = [
  {
    key: 'lastPositionStatus',
    label: 'report.fields.lastPositionStatus',
    header: 'lastPositionStatus',
    filter: false,
    width: 20,
  },
  {
    key: 'lastReceive',
    label: 'report.fields.lastReceive',
    header: 'lastReceive',
    filter: false,
    width: 20,
  },
  {
    key: 'licensePlate',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: false,
    width: 20,
  },
  {
    key: 'vgroups',
    label: 'report.fields.vehicleGroup',
    header: 'vgroups',
    filter: false,
    width: 20,
  },
  {
    key: 'motionStatus',
    label: 'report.fields.motionStatus',
    header: 'motionStatus',
    filter: false,
    width: 20,
  },
  {
    key: 'speed',
    label: 'report.fields.speed',
    header: 'speed',
    filter: false,
    width: 10,
  },
  {
    key: 'fuel',
    label: 'report.fields.fuel',
    header: 'fuel',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature',
    label: 'report.fields.temperatureCensor1',
    header: 'temperature',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature2',
    label: 'report.fields.temperatureCensor2',
    header: 'temperature2',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature3',
    label: 'report.fields.temperatureCensor3',
    header: 'temperature3',
    filter: false,
    width: 10,
  },
  {
    key: 'door1',
    label: 'report.fields.censorDoor1',
    header: 'door1',
    filter: false,
    width: 10,
  },
  {
    key: 'door2',
    label: 'report.fields.censorDoor2',
    header: 'door2',
    filter: false,
    width: 10,
  },
  {
    key: 'acc',
    label: 'report.object.acc',
    header: 'acc',
    filter: false,
    width: 10,
  },
  {
    key: 'refrigerator',
    label: 'report.fields.refrigerator',
    header: 'refrigerator',
    filter: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 30,
  },
  {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  },
]

export default fields
